var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeSizeicon = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3A1.5 1.5 0 003 4.5v9A1.5 1.5 0 004.5 15h9a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0013.5 3h-9zM4 4.5a.5.5 0 01.5-.5h3.793L4 8.293V4.5zm0 5.207V13.5a.5.5 0 00.5.5h3.793L4 9.707zM9.707 14H13.5a.5.5 0 00.5-.5V9.707L9.707 14zM14 8.293V4.5a.5.5 0 00-.5-.5H9.707L14 8.293zm-5 5L4.707 9 9 4.707 13.293 9 9 13.293z"
  })));
});
export default SvgHomeSizeicon;